import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAutoLoginFinished } from '@/store/selectors/autoLoginSelectors';
import { selectUserLoading } from '@/store/selectors/userSelectors';
import LoadingSpinner from '@/components/shared/spinner/LoadingSpinner';
import ControlsCenter from '@/pages/home/hero/thailand/ControlsCenter';
import FeaturedCenter from '@/pages/home/hero/thailand/FeaturedCenter';
import { cdnImage } from '@/utils/image-utils';
import { openModal } from '@/store/actions/modal';

const HomeHeroContentPrivateThailand = () => {
  const autoLoginFinished = useSelector(selectAutoLoginFinished);
  const userLoading = useSelector(selectUserLoading);
  const dispatch = useDispatch();

  const handleOpenLineChat = () => {
    dispatch(openModal('lineChat'));
  };

  if (!autoLoginFinished || userLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="grid grid-cols-1 gap-8 justify-center items-center w-full p-4 py-36">
      <ControlsCenter />
      <div className="lg:absolute lg:left-8 md:bottom-8">
        <FeaturedCenter />
      </div>
      <div className="absolute bottom-8 right-8 cursor-pointer" onClick={handleOpenLineChat}>
        <img
          className="hidden md:block"
          width="200px"
          src={cdnImage('line-chat-cat.png', {
            width: '200',
            height: 'auto',
            fit: 'contain',
          })}
          alt="Line chat"
        />
        <img
          className="block md:hidden w-10"
          alt="LINE Chat"
          src={cdnImage('line-app.png', {
            width: '48',
            height: '48',
            fit: 'contain',
            dpr: '2',
          })}
        />
      </div>
    </div>
  );
};

export default HomeHeroContentPrivateThailand;
